import React, { useState, useEffect } from "react";
import EmployeeForm from "./employee_form";
import Datatables from "../../../utils/table/datatable";
import { EmployeeColumns } from "helpers/DatatableColumns";
import { get } from "helpers/api_helper";
import { EMPLOYEE } from "helpers/url_helper";

const Employee = () => {
    const [ isForm , setIsForm ] = React.useState(false);
    const [ employeesList, setEmployeeList ] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    const toggleForm = () => {
        setIsForm(!isForm);
        if(isForm == false){
            getEmployeeList();
        }
    }

    const getEmployeeList = async () => {
        const { success, data } = await get(`${EMPLOYEE}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setEmployeeList(data);
        }
    }

    useEffect(() => {
        const fetchData = setTimeout(() => {
            getEmployeeList();
        }, 500);

        return () => clearTimeout(fetchData);
    }, [pagination.page, pagination.limit, pagination.search]);

    return (
        isForm ? <EmployeeForm cb={toggleForm} /> :
            <Datatables 
                isSearch={true}
                columns = {EmployeeColumns}
                showTableOnly={true}
                rowsLength={employeesList?.totalRows || 0}
                rows = {employeesList?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Employees"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Employee;